<div class="pt-4">
  <!-- title -->
  <div class="d-flex flex-column gap-4 align-items-center mt-5">
    <div class="fs-2 direction-1 fw-bold">
      {{ "imakeapp system" | translate }}
    </div>
    <div class="fs-3 line-height-1 fw-bold text-center">
      {{
        "One of the best management and marketing programs for restaurants and stores"
          | translate
      }}
      <br />
      {{
        "It includes more than 10 different programs to serve the store or restaurant"
          | translate
      }}
    </div>
  </div>

  <!-- section-1 -->
  <div class="d-flex mt-md-8 section-box row">
    <div class="col-md-7">
      <h1 class="list-items fw-bold fs-3 mb-4">
        {{ "restaurant customers" | translate }}
      </h1>
      <p class="list-items line-height-1 fs-5 mb-5">
        {{
          "Where it first serves the customers of the restaurant through two applications, ios - android native, so that the customer can view the products and offers of the restaurant continuously, as well as the possibility of ordering and tracking an order through the application, as well as evaluation, and here are the most important features of the customer application"
            | translate
        }}
      </p>
    </div>

    <div class="col-md-5 sub-box mt-md--11 restaurant-customers">
      <div class="d-flex justify-content-center">
        <div class="position-relative">
          <img
            src="../../assets/images/imakeapp-restaurants/img-section-1.svg"
            alt="woman ordering food using mobile"
            class="img-1 img-section-1"
          />
        </div>
      </div>
    </div>
    <div class="col-md-7">
      <ul class="points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let clientsAppFeature of clientsAppFeatures1">
          <p class="list-items">
            {{ clientsAppFeature | translate }}
          </p>
        </li>
      </ul>
    </div>
    <div class="col-md-5 d-flex align-items-end mt-3">
      <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let clientsAppFeature of clientsAppFeatures2">
          <p class="list-items">
            {{ clientsAppFeature | translate }}
          </p>
        </li>
      </ul>
    </div>
  </div>

  <!-- section-2 -->
  <div class="d-flex flex-column gap-5 mt-3 section-2 section-box">
    <!-- top -->
    <div class="d-flex flex-column flex-lg-row justify-content-between">
      <!-- right -->
      <div class="d-flex flex-column gap-2 sub-box restaurant-customers">
        <div class="d-flex justify-content-center position-relative">
          <img
            src="../../assets/images/imakeapp-restaurants/img-section-5.svg"
            alt="woman ordering food using mobile"
            class="img-1 img-section-5"
          />
        </div>
      </div>

      <!-- left -->
      <div
        class="d-flex flex-column gap-5 justify-content-center right sub-box"
      >
        <h1 class="list-items fw-bold fs-3">
          {{ "Restaurant application to receive orders" | translate }}
        </h1>
        <p class="list-items line-height-1 fs-5">
          {{
            "We designed an application dedicated to the store or restaurant through which it receives orders, accepts them, determines the timing of preparation, and also sends them to the representative"
              | translate
          }}
        </p>
      </div>
    </div>

    <!-- down -->
    <div
      class="d-flex flex-column flex-lg-row gap-3 justify-content-between"
    >
      <!-- right -->
      <div class="d-flex flex-column gap-5 sub-box right">
        <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
          <li *ngFor="let ordersAppFeature of ordersAppFeatures1">
            <p class="list-items">
              {{ ordersAppFeature | translate }}
            </p>
          </li>
        </ul>
      </div>

      <!-- left -->
      <div class="d-flex flex-column gap-2 sub-box">
        <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
          <li *ngFor="let ordersAppFeature of ordersAppFeatures2">
            <p class="list-items">
              {{ ordersAppFeature | translate }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- section-3 -->
  <div class="d-flex flex-column flex-lg-row gap-3 mt-3 section-box">
    <!-- right -->
    <div class="d-flex flex-column gap-5 sub-box right">
      <h1 class="list-items fw-bold fs-3">
        {{ "Restaurant Delivery application" | translate }}
      </h1>
      <p class="list-items line-height-1 fs-5">
        {{
          "We did not forget your delegates, as we designed a wonderful application to send requests to the representative and also follow him on the map, through these points"
            | translate
        }}
      </p>
      <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let deliveriesAppFeature of deliveriesAppFeatures">
          <p class="list-items">
            {{ deliveriesAppFeature | translate }}
          </p>
        </li>
      </ul>
    </div>

    <!-- left -->
    <div class="d-flex flex-column gap-2 sub-box justify-content-center ">
      <div class="d-flex justify-content-center position-relative">
          <img
            src="../../assets/images/imakeapp-restaurants/img-section-6.svg"
            alt="woman ordering food using mobile"
            class="img-1 img-section-6"
          />
      </div>
    </div>
  </div>

  <!-- section-4 -->
  <div class="d-flex flex-column gap-5 mt-3 section-2 section-box">
    <!-- top -->
    <div class="d-flex flex-column flex-lg-row justify-content-between">
      <!-- right -->
      <!-- <div class="d-flex flex-column gap-2 sub-box right restaurant-customers">
        <div class="d-flex justify-content-center position-relative">
            <img
              src="../../assets/images/imakeapp-restaurants/img-section-3.svg"
              alt="woman ordering food using mobile"
              class="img-1 img-section-3"
            />
        </div>
      </div> -->

      <!-- left -->
      <div class="d-flex flex-column gap-5 justify-content-center sub-box">
        <h1 class="list-items fw-bold fs-3">
          {{ "A Dashboard for your entire restaurant" | translate }}
        </h1>
        <p class="list-items line-height-1 fs-5">
          {{
            "Thanks to the complete control system in the control panel in modern technologies, modern technologies and here are the most important features of the panel"
              | translate
          }}
        </p>
      </div>
    </div>

    <!-- down -->
    <div class="d-flex flex-column flex-lg-row gap-3 justify-content-between">
      <!-- right -->
      <div class="d-flex flex-column gap-5 sub-box right">
        <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
          <li *ngFor="let dashboardFeature of dashboardFeatures1">
            <p class="list-items">
              {{ dashboardFeature | translate }}
            </p>
          </li>
        </ul>
      </div>

      <!-- left -->
      <div class="d-flex flex-column gap-2 sub-box">
        <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
          <li *ngFor="let dashboardFeature of dashboardFeatures2">
            <p class="list-items">
              {{ dashboardFeature | translate }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- section-5 -->
  <div class="d-flex flex-column flex-lg-row gap-3 mt-3 section-box">
    <!-- right -->
    <div class="d-flex flex-column gap-5 sub-box right">
      <h1 class="list-items fw-bold fs-3">
        {{
          "Control panel for each branch of the restaurant or store" | translate
        }}
      </h1>
      <p class="list-items line-height-1 fs-5">
        {{
          "If you have more than one branch of the restaurant, the imakeapp system provides you with a control panel for each branch to manage the entire branch"
            | translate
        }}
      </p>
      <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let branchDashboardFeature of branchDashboardFeatures">
          <p class="list-items">
            {{ branchDashboardFeature | translate }}
          </p>
        </li>
      </ul>
    </div>

    <!-- left -->
    <!-- <div class="d-flex flex-column gap-2 sub-box justify-content-center">
      <div class="d-flex justify-content-center">
        <div class="position-relative">
          <img
            src="../../assets/images/imakeapp-restaurants/img-section-7.svg"
            alt="woman ordering food using mobile"
            class="img-1 img-section-7"
          />
        </div>
      </div>
    </div> -->
  </div>

  <!-- section-6-->
  <div class="d-flex flex-column gap-5 mt-3 section-2 section-box">
    <!-- top -->
    <div class="d-flex flex-column flex-lg-row justify-content-between gap-5">
      <!-- right -->
      <div class="d-flex flex-column gap-2 sub-box">
        <div class="d-flex justify-content-center">
          <div class="position-relative">
            <img
              src="../../assets/images/imakeapp-restaurants/macbook air-2@2x.png"
              alt="woman ordering food using mobile"
              class="img-1 w-100"
            />
          </div>
        </div>
      </div>

      <!-- left -->
      <div
        class="d-flex flex-column gap-5 justify-content-center right sub-box"
      >
        <h1 class="list-items fw-bold fs-3">
          {{ "Restaurant website" | translate }}
        </h1>
        <p class="list-items line-height-1 fs-5">
          {{
            "So that the customer can constantly view the restaurant’s products and offers, as well as the possibility of requesting and tracking an order through the application, as well as evaluation, and here are the most important features of the customer’s application"
              | translate
          }}
        </p>
      </div>
    </div>

    <!-- down -->
    <div class="d-flex flex-column flex-lg-row gap-3 justify-content-between">
      <!-- right -->
      <div class="d-flex flex-column gap-5 sub-box right">
        <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
          <li *ngFor="let websitefeature of websitefeatures1">
            <p class="list-items">
              {{ websitefeature | translate }}
            </p>
          </li>
        </ul>
      </div>

      <!-- left -->
      <div class="d-flex flex-column gap-2 sub-box">
        <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
          <li *ngFor="let websitefeature of websitefeatures2">
            <p class="list-items">
              {{ websitefeature | translate }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- section-7 -->
  <div class="d-flex flex-column flex-lg-row gap-3 mt-3 section-box pb-0">
    <!-- right -->
    <div class="d-flex flex-column gap-5 sub-box right">
      <h1 class="list-items fw-bold fs-3">
        {{
          "An application to take requests for the lounge from Waiter"
            | translate
        }}
      </h1>
      <p class="list-items line-height-1 fs-5">
        {{
          "Taking orders has never been easy no need for paper or anything else, we got you covered with everything you need to manage and take orders in you hall using our cutting-age application specifically made for restaurants hall experience."
            | translate
        }}
      </p>
      <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let waitersOrdersAppFeature of waitersOrdersAppFeatures">
          {{ waitersOrdersAppFeature | translate }}
        </li>
      </ul>
    </div>

    <!-- left -->
    <div class="d-flex flex-column gap-2 sub-box justify-content-center">
      <div class="d-flex justify-content-center">
        <div class="position-relative">
          <img
            src="../../assets/images/imakeapp-restaurants/Tablet in Hand@2x.png"
            alt="woman ordering food using mobile"
            class="img-1 img-section-8"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- <app-packages [packages]="packages"></app-packages> -->

  <div class="py-5"></div>

</div>

<promo-video></promo-video>
